import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	removeTooltip: {
		id: 'issue-smart-links-popup-edit-view.smart-link-options-trigger.remove-button.remove-all-tooltip',
		defaultMessage: 'Remove',
		description: 'Tooltip message shown for the button to remove a link.',
	},
});
